import spacing from "../../theme/spacing";

export const ROW_CONTAINER_VERTICAL_PADDING = "12px";
export const ROW_LINK_VERTICAL_PADDING = "2px";
export const ROW_LINK_HORIZONTAL_PADDING = "4px";
export const ROW_DATE_SMALL_WIDTH = "121px";
export const ROW_DATE_MEDIUM_WIDTH = "136px";
export const ROW_LABEL_AND_LINK_PADDING_LEFT = {
  xSmall: ROW_DATE_SMALL_WIDTH,
  medium: "181px",
  large: "183px"
};
export const ROW_BUTTON_WIDTH = "102px";
export const CHEVRON_ICON_SIZE = 15;
export const CHEVRON_ICON_PADDING = spacing.moderate;

export const staticProps = {
  defaultResponsiveSize: { xSmall: "hecto", medium: "kilo" }
};
